import React, { useState } from "react";
import styles from "./BidToolConfigurationView.module.scss";
import { Col, message, Tabs } from "antd";
import TruckAssumptionsContent from "./TruckAssumptionsContent";
import Form from "../Form";
import BidCalculatorInputs from "./BidCalculatorInputs";
import RunInformation from "./RunInformation";
import {
  getDefaultValues,
  validationSchemas,
  stepThreeKeys,
  stepTwoKeys,
  stepOneKeys,
  overallConstants,
  getTruckAssumptionValidation,
} from "./constants";
import BidToolConfigServices from "../../services/bidToolConfig.service";
import TNLoader from "../../reusable-components/TNLoader";

interface FormValues {
  baseTruckAssumption: any;
  bidCalculationInputs: any;
  runInformation: any;
  multiLoadFuelBidChart: any;
}

const BidToolConfigurationView = () => {
  const { TabPane } = Tabs;
  const { FetchSettingsBidConfig } = BidToolConfigServices();
  const [currentTab, setCurrentTab] = useState(undefined);
  const [currentSave, setCurrentSave] = useState(false);
  const {
    STEP_ONE_ERROR_MESSAGE,
    STEP_TWO_ERROR_MESSAGE,
    STEP_THREE_ERROR_MESSAGE,
    TAB_BASE_TRUCK_ASSUMPTIONS,
    TAB_BID_CALCULATOR_INPUTS,
    TAB_RUN_INFORMATION,
  } = overallConstants;
  const {
    data: bidConfigSettingsData,
    refetch,
    isFetching,
  } = FetchSettingsBidConfig(currentTab);
  const defaultValues = getDefaultValues(bidConfigSettingsData);
  const handleSaveOption = (val: boolean) => {
    setCurrentSave(val);
    if (val) {
      refetch();
    }
  };

  return (
    <>
      <TNLoader isLoading={isFetching} />
      <div className={styles.CardContainer}>
        <div className={styles.CardWrapper}>
          <Col span={24}>
            <div className={styles.TabDetailContainer}>
              <Form
                values={defaultValues}
                validationSchema={getTruckAssumptionValidation(
                  bidConfigSettingsData
                ).concat(validationSchemas)}
              >
                {() => {
                  const handleValidationErrors = (errors) => {
                    const keys = errors ? Object.keys(errors) : [];
                    const hasStepOneError = keys.some((key) =>
                      stepOneKeys(bidConfigSettingsData).includes(key)
                    );
                    const hasStepTwoError = keys.some((key) =>
                      stepTwoKeys.includes(key)
                    );
                    const hasStepThreeError = keys.some((key) =>
                      stepThreeKeys.includes(key)
                    );

                    if (hasStepOneError) {
                      message.warning({
                        content: STEP_ONE_ERROR_MESSAGE,
                      });
                      setCurrentTab("1");
                    } else if (hasStepTwoError) {
                      message.warning({
                        content: STEP_TWO_ERROR_MESSAGE,
                      });
                      setCurrentTab("2");
                    } else if (hasStepThreeError) {
                      message.warning({
                        content: STEP_THREE_ERROR_MESSAGE,
                      });
                      setCurrentTab("3");
                    }
                  };
                  return (
                    <Tabs
                      swipeable
                      size="small"
                      type="line"
                      tabPosition="left"
                      defaultActiveKey="1"
                      activeKey={currentTab ?? "1"}
                      onChange={(key) => setCurrentTab(key)}
                    >
                      <TabPane tab={TAB_BASE_TRUCK_ASSUMPTIONS} key="1">
                        <TruckAssumptionsContent
                          initialValues={bidConfigSettingsData}
                          currentTab={currentTab}
                          handleSaveOption={handleSaveOption}
                          handleValidationErrors={handleValidationErrors}
                        />
                      </TabPane>
                      <TabPane tab={TAB_BID_CALCULATOR_INPUTS} key="2">
                        <BidCalculatorInputs
                          initialValues={bidConfigSettingsData}
                          handleSaveOption={handleSaveOption}
                          handleValidationErrors={handleValidationErrors}
                        />
                      </TabPane>
                      <TabPane tab={TAB_RUN_INFORMATION} key="3">
                        <RunInformation
                          initialValues={bidConfigSettingsData}
                          handleSaveOption={handleSaveOption}
                          handleValidationErrors={handleValidationErrors}
                        />
                      </TabPane>
                    </Tabs>
                  );
                }}
              </Form>
            </div>
          </Col>
        </div>
      </div>
    </>
  );
};

export default BidToolConfigurationView;
